export const getCourseLevelFromName = (fullName) => {
  return fullName?.slice(0, 2) || '';
};
